<template>
    <section class="master-main-banner_image pt_custom_wh">
        <div class="jos-inner-banner">
            <img src="/single-product/Wishlist-Banner-Web.webp" class="img-fluid pc lazy-img-dev" alt="Wishlist-Banner-Web">
            <img src="/single-product/Wishlist-Banner-Mobile-2.webp" class="img-fluid mb lazy-img-dev" alt="Wishlist-Banner-Mobile-2">
        </div>
    </section>
</template>